import { PropsWithChildren } from 'react';
import LiquidityResponsesListProvider from '#/leaderboard/contexts/liquidity-responses-list';

export default function LiquidityResponsesProvider({
  children,
}: PropsWithChildren) {
  return (
    <LiquidityResponsesListProvider>{children}</LiquidityResponsesListProvider>
  );
}
